<template>
  <component :is="iconComponent" v-bind="$attrs" />
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'

import { TableIconName } from '@/common/interfaces/TableIconInterfaces'

const props = defineProps<{ name: TableIconName }>()

const modules = import.meta.glob('../../../assets/*.svg', { import: 'default' })
const iconComponent = computed(() => {
  const path = `../../../assets/${props.name}.svg`
  const loader = modules[path]
  if (!loader) return null
  return defineAsyncComponent(loader)
})
</script>
